module.exports = __webpack_public_path__ + "static/img/global_footer_consult@3x.fa3dcff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global_footer_consult@3x.png
// module id = MWK2
// module chunks = 1